import { connect } from 'react-redux';
import { authSelectors } from '../modules/auth';
import UserNavBar from './UserNavBar';

const mapStateToProps = state => ({
  user: authSelectors.getUser(state),
});

export default connect(mapStateToProps)(UserNavBar);
